<app-dialog [title]="data.title" [actions]="[
    { text: 'Cancel', buttonStyle: 'underline' },
    {
      text: 'Remove',
      spin: spin,
      isDisabled: !skuTags.length ,
    }
  ]" (action)="action($event)" (close)="close()">
  <div *ngIf="skuTags.length">
    <div class="selected-sku">
      {{skuTags.length}} Items Selected
    </div>
    <div class="sku" *ngFor="let sku of skuTags;let i = index">
      <div class="sku_action sku_action--error" (click)="removeSku(i)">
        <i class="far fa-times-circle fa-1x"></i>
      </div>
      <div class="sku_image" [style.backgroundImage]="'url(' + sku.imageUrl + ')'"></div>
      <div class="sku_header">
        <div class="sku_title" [matTooltip]="sku.title">
          {{ sku.title }}
        </div>
        <div>
          <app-sku-chip *ngIf="sku.sku" [name]="'SKU'" [value]="sku.sku"></app-sku-chip>
          <app-sku-chip *ngIf="sku.name" [name]="'Name'" [value]="sku.name"></app-sku-chip>
          <app-sku-chip *ngIf="sku.asin" [name]="sku.asin === sku.fnSku ? 'ASIN / FNSKU' : 'ASIN'"
            [value]="sku.asin"></app-sku-chip>
        </div>
      </div>
      <div class="indicator-tags">
        <span class="indicator-tags_tags" *ngFor="let tag of sku.tagsDto;let j = index"
          [style.backgroundColor]="tag?.colorCode">
          {{ tag.name }}
          <span class="tagDelete" (click)="removeTag(j,i)">
            <i class="fal fa-times-circle"></i>
          </span>
        </span>
      </div>
    </div>
  </div>
  <div class="loader" *ngIf="loading">
    <img [src]="'assets/images/nineyard-loading.gif'" />
  </div>
  <div class="d-flex justify-content-center" *ngIf="!skuTags.length && !loading">
    <span class="no-record-found">No Items Selected</span>
  </div>
</app-dialog>